// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"7df38c50","346":"2430c310","438":"50f0e8f6","653":"c2e1cec2","753":"8d773f71","984":"bec08b1f"}[chunkId] + ".chunk.js";
};